import { Pipe, PipeTransform } from '@angular/core';

import { AlertResponse } from '@app/modules/shared/widgets/entities/alerts';
import { invertAlertDateBoundFormat } from '@shared/widgets/mappers/alert-date-format.mapper';

@Pipe({
  name: 'activeAlerts',
  standalone: false
})
export class ActiveAlertsPipe implements PipeTransform {

  constructor() { }

  transform(entites: AlertResponse[]): AlertResponse[] {
    return this.obtainActiveAlerts(entites);
  }

  private obtainActiveAlerts(entites: AlertResponse[]): AlertResponse[] {
    const withFlexDatesInAlert = (alert: AlertResponse): boolean => !!alert && !!alert.flex_dates;

    const departureDate = (alert: AlertResponse): string =>
      alert ? invertAlertDateBoundFormat(alert.outbound_min, withFlexDatesInAlert(alert)) : null;

    const isExpiredAlert = (alert: AlertResponse): boolean => !!departureDate(alert)
      && new Date(departureDate(alert).replace(new RegExp(/-/g), '/')) < new Date();

    return entites.filter(alert => !isExpiredAlert(alert));

  }


}
